import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { DashboardTransaction } from '../../../../../../__generated__/GQL';
import { FiltersData } from '../../../../types';
import FullWidthLineGraph from '../../../components/FullWidthLineGraph';
import LoadingFullWidthLineGraph from '../../../components/FullWidthLineGraph/components/LoadingFullWidthLineGraph';
import {
  GraphEmptyState,
  UnavailableDateEmptyState,
} from '../../../components/TransactionAggregationTable/components/EmptyStates';
import { GraphType } from '../GraphSelector';
import DashboardFilters from './DashboardFilters';

interface GraphWithFilterProps {
  graphData?: DashboardTransaction[];
  filtersData: FiltersData;
  graphType: GraphType;
  empty: boolean;
  hasUnavailableDateRange: boolean;
  dateTickInterval?: number;
}

const GraphWithFilter: FC<GraphWithFilterProps> = ({
  dateTickInterval,
  empty,
  filtersData,
  graphData,
  graphType,
  hasUnavailableDateRange,
}) => {
  if (graphData && empty) {
    return <GraphEmptyState height="300px" marginBottom="space-48" />;
  }
  if (graphData && hasUnavailableDateRange) {
    return <UnavailableDateEmptyState height="375px" marginTop="space-24" />;
  }

  return (
    <Box minWidth="900px">
      <Box
        height="300px"
        marginBottom="space-48"
        mt="10px"
        position="relative"
        width="100%"
      >
        {graphData ? (
          <FullWidthLineGraph
            data={graphData}
            dateTickInterval={dateTickInterval}
          />
        ) : (
          <LoadingFullWidthLineGraph />
        )}
      </Box>

      <DashboardFilters data={filtersData} graphType={graphType} />
    </Box>
  );
};

export default GraphWithFilter;
